import YubinBango from 'yubinbango-core2'

const Zipcode = () => {
  const inputElm = document.getElementById("js-zipcodeInput"),
        outputElm = document.getElementById("js-zipcodeOutput");
  if(inputElm === null || outputElm === null) return;
  inputElm.addEventListener('input', function(e) {
    if(inputElm.value.length === 7) {
      try {
        new YubinBango.Core(inputElm.value, (res)=> {
          outputElm.value = res.region + res.locality + res.street + res.extended;
          outputElm.focus();
        });
      } catch(e) {
      }
    } else {
      outputElm.value = '';
    }
  });
}

export default Zipcode;